import { Boat } from "shared/api/types";

export function getBoatByIRI(boats: Boat[], id: string | null): Boat | null {
  return boats.find((boat) => boat["@id"] === id) ?? null;
}
